import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';

import { useDraggable } from "@dnd-kit/core";
import { FixedSizeList as List } from 'react-window';
import { Icon } from '@blueprintjs/core';
import classNames from "classnames";

import { ShowHide } from 'components/layout';
import { FormTextInput, FormSwitch } from "components/form-fields";
import { useDebounce } from 'hooks/useDebounce';
import './DraggableList.css';

function DraggableRow(props) {

    var item = props.item;
    var style = props.style;
    var itemSpacing = props.itemSpacing;
    var disabled = props.disabled;

    var {
        attributes,
        listeners,
        setNodeRef,
        isDragging
    } = useDraggable({
        id: `${item.id}`,
        disabled: disabled
    });

    var rowStyle = {
        ...style,
        top: style.top + itemSpacing,
        width: style.width - itemSpacing,
        height: style.height - itemSpacing,
        opacity: isDragging ? 0 : undefined
    };

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            className={classNames("draggable-list-item", item.class, { "draggable-list-item-fixed": !isDragging, "draggable-list-item-dragged": isDragging, "draggable-list-item-duplicate": item.assignedCount != null && item.assignedCount > 1 && !isDragging })}
            style={rowStyle}
        >
            {item.name}
            <ShowHide
                evaluator={item.assignedCount != null && item.assignedCount > 1 && !isDragging}
                show={(
                    <div className="list-item-duplicate">
                        <Icon className="draggable-item-duplicate" icon="duplicate" size={12} />
                    </div>
                )}
            />
        </div>
    );
}

export function DraggableList(
    {
        loading = false,
        disabled = false,
        filterLabel = "",
        items,
        onFilterItems
    }
) {

    const debounceTimeout = 250;
    const itemSpacing = 10;

    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, debounceTimeout);
    const [isFiltered, setIsFiltered] = useState(true);

    useEffect(function () {
        onFilterItems(debouncedSearchTerm, isFiltered);
    }, [debouncedSearchTerm, isFiltered]);

    function onSearchChange(item) {
        setSearchTerm(item.target.value);
    }

    function onFilterChange() {
        setIsFiltered((previous) => {
            return !previous;
        })
    }

    const Row = ({ index, style }) => {

        var item = items[index];

        return (
            <DraggableRow
                key={item.id}
                item={item}
                style={style}
                itemSpacing={itemSpacing}
                disabled={disabled}
            />
        );
    }

    return (
        <div className="location-listing-container">
            <div className="inline-item fluid-item">
                <FormTextInput id="locationList-search-field" placeholder="Search Location List" onChange={onSearchChange} value={searchTerm} icon="search" loading={loading} disabled={disabled} />
            </div>
            <div className="spacer-small inline-item form-field-inline-switcher-container">
                <span className={classNames("form-field-inline-switcher-label", { "bp6-skeleton": loading })}>{filterLabel}</span>

                <div className="form-field-inline-switcher">
                    <FormSwitch id="locationList-show-ungrouped-locations" onChange={onFilterChange} checked={isFiltered} inline={true} alignment="end" loading={loading} disabled={disabled} />
                </div>
            </div>
            <div className="spacer-bottom location-items">
                <div
                    style={{
                        width: "100%",
                        minHeight: "auto",
                    }}
                >
                    <List
                        height={500}
                        itemCount={items.length}
                        itemSize={36}
                        width={210}
                        itemData={items}
                    >
                        {Row}
                    </List>
                </div>
            </div>
        </div>
    );
}

DraggableList.propTypes = {
    id: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    filterLabel: PropTypes.string,
    onFilterItems: PropTypes.func.isRequired
};
